(function(window, ieFullscreenDimensionsFixDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.ieFullscreenDimensionsFix = ieFullscreenDimensionsFixDefinition(window, window.document, window.$);
})(this, function(window, document, $) {
   'use strict';

   var _$body;
   var _original = {
      width: $.fn.width,
      innerWidth: $.fn.innerWidth,
      outerWidth: $.fn.outerWidth,
      height: $.fn.height,
      innerHeight: $.fn.innerHeight,
      outerHeight: $.fn.outerHeight,
      offset: $.fn.offset
   };

   var hMargin = function($el) {
      return parseInt($el.css('margin-left'), 10) + parseInt($el.css('margin-right'), 10);
   };

   var vMargin = function($el) {
      return parseInt($el.css('margin-top'), 10) + parseInt($el.css('margin-bottom'), 10);
   };

   var hPadding = function($el) {
      return parseInt($el.css('padding-left'), 10) + parseInt($el.css('padding-right'), 10);
   };

   var vPadding = function($el) {
      return parseInt($el.css('padding-top'), 10) + parseInt($el.css('padding-bottom'), 10);
   };

   var hBorder = function($el) {
      return parseInt($el.css('border-left-width'), 10) + parseInt($el.css('border-right-width'), 10);
   };

   var vBorder = function($el) {
      return parseInt($el.css('border-top-width'), 10) + parseInt($el.css('border-bottom-width'), 10);
   };

   var initialize = function($container) {
      _$body = $('body');

      var isIEFullscreenDimensionsBugInEffect = function() {
         return document.msFullscreenElement && _original.width.call(_$body) !== _original.width.call($container);
      };

      $.fn.width = function() {
         if (arguments.length === 0 && 0 in this && isIEFullscreenDimensionsBugInEffect() && this[0] !== window) {
            return Math.round(this[0].getBoundingClientRect().width * 100 - hPadding(this) - hBorder(this));
         }
         return _original.width.apply(this, $.makeArray(arguments));
      };

      $.fn.innerWidth = function() {
         if (arguments.length === 0 && 0 in this && isIEFullscreenDimensionsBugInEffect() && this[0] !== window) {
            return Math.round(this[0].getBoundingClientRect().width * 100 - hBorder(this));
         }
         return _original.innerWidth.apply(this, $.makeArray(arguments));
      };

      $.fn.outerWidth = function(includeMargin) {
         var value;
         if (arguments.length <= 1 && 0 in this && isIEFullscreenDimensionsBugInEffect() && this[0] !== window) {
            value = Math.round(this[0].getBoundingClientRect().width * 100);
            return includeMargin ? value + hMargin(this) : value;
         }
         return _original.outerWidth.apply(this, $.makeArray(arguments));
      };

      $.fn.height = function() {
         if (arguments.length === 0 && 0 in this && isIEFullscreenDimensionsBugInEffect() && this[0] !== window) {
            return Math.round(this[0].getBoundingClientRect().height * 100 - vPadding(this) - vBorder(this));
         }
         return _original.height.apply(this, $.makeArray(arguments));
      };

      $.fn.innerHeight = function() {
         if (arguments.length === 0 && 0 in this && isIEFullscreenDimensionsBugInEffect() && this[0] !== window) {
            return Math.round(this[0].getBoundingClientRect().height * 100 - vBorder(this));
         }
         return _original.innerHeight.apply(this, $.makeArray(arguments));
      };

      $.fn.outerHeight = function(includeMargin) {
         var value;
         if (arguments.length <= 1 && 0 in this && isIEFullscreenDimensionsBugInEffect() && this[0] !== window) {
            value = Math.round(this[0].getBoundingClientRect().height * 100);
            return includeMargin ? value + vMargin(this) : value;
         }
         return _original.outerHeight.apply(this, $.makeArray(arguments));
      };

      $.fn.offset = function() {
         var offset;
         if (arguments.length === 0 && 0 in this && isIEFullscreenDimensionsBugInEffect()) {
            offset = _original.offset.apply(this);
            if (offset) {
               offset.top = Math.round(offset.top * 100);
               offset.left = Math.round(offset.left * 100);
            }
            return offset;
         }
         return _original.offset.apply(this, $.makeArray(arguments));
      };
   };

   return {
      initialize: initialize
   };
});
